<template lang="pug">
.panel(v-if="showPanel", :style="panelStyle")
  header.header
    .header-label 上传列表 ({{ uploader.files.length }})
    //- button(@click="generate()") generate file
    i.el-icon-minus(aria-label="minus", rel="button", @click="toggleCollapse()")
    i.el-icon-close(aria-label="close", rel="button", @click="toggleVisible()")
  template(v-if="!collapse")
    .control
      ul.status-list
        li(v-for="item in statusList", :key="item.id", :class="{ active: item.id === statusName }", @click="statusName = item.id")
          | {{ item.cnName }}
          | ( #[span(:class="item.style") {{ doFilterList(item.id).length }}])
      .filter
        el-input(size="small", v-model.trim="filterText", placeholder="请输入关键字", clearable, prefix-icon="el-icon-search")
    ul.list(v-if="filterList.length")
      IFile(v-for="file in filterList", :key="file.id", :file="file")
    .empty(v-else)
      img(src="./assets/empty.png", alt="empty")
</template>
<script>
import { lowerCase, random, filter, compact, map, reject, includes } from "lodash-es";
import IFile from "./IFile.vue";
import { IUploader } from "./IUploader.js";
const { utils } = IUploader;

export default {
  components: { IFile },
  data() {
    return {
      /** @type {IUploader} */
      uploader: undefined,
      visible: true,
      collapse: false,
      statusName: "",
      filterText: "",
      statusList: [
        { id: "", cnName: "上传中", style: "text-primary" },
        { id: utils.STATUS.SUCCESS, cnName: "成功", style: "text-success" },
        { id: utils.STATUS.ERROR, cnName: "失败", style: "text-error" }
      ]
    };
  },
  computed: {
    showPanel() {
      return this.visible && !!this.fileList.length;
    },
    filterList() {
      const { filterText } = this;
      const list = this.doFilterList(this.statusName);
      const key = lowerCase(filterText);
      if (filterText) {
        return list.filter(({ fullName }) => lowerCase(fullName).indexOf(key) + 1);
      } else {
        return list;
      }
    },
    fileList() {
      return this.uploader.files;
    },
    panelStyle() {
      const style = {};
      if (this.showPanel) {
        style.zIndex = utils.nextZIndex() + 1;
      }
      return style;
    }
  },
  methods: {
    toggleCollapse(collapse = !this.collapse) {
      this.collapse = collapse;
    },
    async toggleVisible(visible = !this.visible) {
      if (this.visible && this.doFilterList("").length) await this.$confirm("上传列表关闭,未上传成功的文件将取消上传,确定关闭?", "提示", { type: "warning" });
      this.uploader.clear();
      this.visible = visible;
    },
    doFilterList(status) {
      if (!status) {
        const disable = compact(map(this.statusList, "id"));
        return reject(this.fileList, (f) => includes(disable, f.status));
      }
      return filter(this.fileList, { status });
    },
    async generate() {
      const list = Array.from({ length: random(1, 1) }, () => {
        const number = random(3 * 10 ** 8, 4 * 10 ** 8);
        // const number = random(2000000, 10000000);
        // const number = random(1000000, 4000000);
        // const number = random(2000, 3000);
        const buffer = new ArrayBuffer(number);
        const typeArr = new Uint8Array(buffer).fill(32, number >> 2);
        const fileName = `${number}.bin`;
        return new File([typeArr], fileName, {
          type: "application/octet-stream"
        });
      });
      const fileList = this.uploader.addFile(list, { once: false, params: { enterpriseId: "4092291521314816", prjId: "351794521832423424", folderId: "351794985252683776" }});
      const info = await fileList.promise;
      console.log(info);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/CommonDP/styles/mixin";
.panel {
  background-color: #fffd;
  position: fixed;
  right: 16px;
  bottom: 16px;
  width: 600px;
  backdrop-filter: blur(4px);
  border-radius: 4px;
  box-shadow: 0 0 8px -4px #000a;
  .header {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    padding: 0 18px;
    &-label {
      flex: 1 1;
      color: #2e384d;
      font-size: 16px;
      font-weight: 400;
    }
    [rel="button"] {
      margin: 0 6px;
      cursor: pointer;
      font-size: 14px;
    }
  }
  .control {
    display: flex;
    height: 46px;
    padding: 0px 20px;
    flex-flow: row nowrap;
    justify-content: space-between;
    background: #f6f6f6;
    align-items: center;
    flex-shrink: 0;
  }
  .status-list {
    display: flex;
    flex: 1 0 auto;
    flex-flow: row nowrap;
    li {
      display: flex;
      font-size: 14px;
      flex-flow: row nowrap;
      margin-right: 12px;
      padding: 3px 6px;
      border-radius: 2px;
      transition: all 0.2s;
      cursor: pointer;
      > span {
        font-size: 14px;
      }
      &:hover,
      &.active {
        background: #ddd;
      }
    }
  }
}
.list {
  padding: 0 12px;
  overflow: auto;
  scrollbar-width: none;
}
.empty {
  text-align: center;
  pointer-events: none;
}
.empty,
.list {
  margin-bottom: 32px;
  height: 300px;
}
.text-primary {
  color: $--color-primary;
}
.text-success {
  color: $--color-success;
}
.text-error {
  color: $--color-danger;
}
</style>
